module.exports = __webpack_public_path__ + "angular/components/header/ebHeader-92e6198c.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/header/ebHeader.html
// module id = 57
// module chunks = 0